import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><g transform="translate(2 2)" strokeWidth="2" fill="none" fillRule="evenodd"><circle stroke="#D7D7D7" cx="5.24" cy="5.24" r="4.24" /><path stroke="#D8D8D8" strokeLinecap="round" strokeLinejoin="round" d="M9.16 8.29L12 10.91" /></g></svg>);